import React, { ChangeEvent, useState } from 'react';
import { CustomFloatingFilterProps } from 'ag-grid-react';

import { useDebounceCallback } from '@hooks/useDebounce';

/**
 * Floating filter for the patient name column
 * Debounces entries to prevent excessive API calls
 * Sanitizes user input in OpenReplay recordings
 */

export const PatientNameFloatingFilter: React.FC<CustomFloatingFilterProps> = props => {
  const { model, onModelChange } = props;
  const debounceMs = 500;

  const [value, setValue] = useState<string>(model?.filter || '');

  const handleModelChange = useDebounceCallback((newValue: string) => {
    if (newValue) {
      onModelChange({
        type: 'contains',
        filter: newValue,
      });
    } else {
      onModelChange(null);
    }
  }, debounceMs);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    handleModelChange(newValue);
  };

  return (
    <input
      aria-label='Filter by Patient Name'
      className='ag-input-field-input ag-text-field-input'
      name='patient_name'
      onChange={handleChange}
      type='text'
      value={value}
      data-openreplay-sanitize
    />
  );
};
